import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { components } from 'src/assets/api/schema';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { modelResolve$ } from 'src/app/infrastructure/functions/model-resolve.function';

type UserDto = components['schemas']['UserDto'];

// De losse accountpagina's (PasswordChange/EmailChange/Settings): de backend controleert hier Page_Read op de
// pagina en stuurt de claims van die pagina mee (ApiService-middleware past ze toe). Geen recht → de
// navigatie wordt geannuleerd (zie modelResolve$), de pagina wordt dan niet geopend.
export const emailChangeModelResolver: ResolveFn<UserDto | undefined> = (_route: ActivatedRouteSnapshot) => {
    const __apiService = injectRequired(ApiService);

    return modelResolve$(__apiService.GET('/api/Account/email-change', {}));
};

export const passwordChangeModelResolver: ResolveFn<UserDto | undefined> = (_route: ActivatedRouteSnapshot) => {
    const __apiService = injectRequired(ApiService);

    return modelResolve$(__apiService.GET('/api/Account/password-change', {}));
};

export const settingsModelResolver: ResolveFn<UserDto | undefined> = (_route: ActivatedRouteSnapshot) => {
    const __apiService = injectRequired(ApiService);

    return modelResolve$(__apiService.GET('/api/Account/settings', {}));
};
